import { miniPersistStore } from "src/models/MiniPersistStore";
import Fetcher from "@netless/fetch-middleware";
if (!process.env.CONSOLE_LAMBDA_ORIGIN) {
    throw new Error("need set process.env.CONSOLE_LAMBDA_ORIGIN");
}
const fetcher = new Fetcher(10000, process.env.CONSOLE_LAMBDA_ORIGIN);


export class ProjectOperator {

    public async getProjects(): Promise<any> {
        const json = await fetcher.get<any>({
            path: `apps`,
            headers: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }
    public async getProjectByUuid(uuid: string): Promise<any> {
        const json = await fetcher.get<any>({
            path: `apps/${uuid}`,
            headers: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }

    public async getProjectToken(ak: string, sk: string): Promise<any> {
        const json = await fetcher.post<any>({
            path: `teams/sdk-token`,
            headers: {
                token: miniPersistStore.token,
            },
            body: {
                ak: ak,
                sk: sk,
            },
        });
        return json as any;
    }

    public async getAccessKey(uuid: string): Promise<any> {
        const json = await fetcher.get<any>({
            path: `apps/${uuid}/access-keys`,
            headers: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }

    public async createApp(name: string): Promise<any> {
        const json = await fetcher.post<any>({
            path: `apps`,
            headers: {
                token: miniPersistStore.token,
            },
            body: {
                name: name,
            },
        });
        return json as any;
    }

    public async deleteApp(uuid: string): Promise<any> {
        const json = await fetcher.delete<any>({
            path: `apps/${uuid}`,
            headers: {
                token: miniPersistStore.token,
            },
            body: {
                uuid: uuid,
            },
        });
        return json as any;
    }

    public async switchAppEnable(uuid: string, ak: string, isBan: boolean): Promise<any> {
        const json = await fetcher.put<any>({
            path: `apps/${uuid}/access-keys/${ak}`,
            headers: {
                token: miniPersistStore.token,
            },
            body: {
                isBan: isBan,
            },
        });
        return json as any;
    }

    public async editProjectName(name: string, uuid: string): Promise<any> {
        const json = await fetcher.patch<any>({
            path: `apps/${uuid}`,
            headers: {
                token: miniPersistStore.token,
            },
            body: {
                name: name,
            },
        });
        return json as any;
    }
}



// WEBPACK FOOTER //
// ./src/apiMiddleware/ProjectOperator.ts